import { Box, Typography } from "@mui/material"

export interface Props {
  children?: React.ReactNode;
  title: string;
}

export const ExtraWACardWithHeader = (props: Props) => {
  return (
    <Box sx={{
      borderRadius: 2.5,
      borderStyle: "solid",
      borderColor: "primary.light",
      borderWidth: 1,
      "@media print": {
        maxHeight: "none",
        overflow: "visible",
        pageBreakInside: "avoid",
      }
    }}>
      {/*title*/}
      <Box sx={{ backgroundColor: "primary.light", borderTopLeftRadius: 7, borderTopRightRadius: 7, WebkitPrintColorAdjust: "exact", printColorAdjust: "exact" }}>
        <Typography variant="subtitle2" sx={{ color: "primary.main", p: 1 }}>{props.title}</Typography>
      </Box>

      {/*content*/}
      <Box sx={{
        p: 1
      }}>
        {props.children}
      </Box>


    </Box>

  )
}